import { render } from "./ButtonDeleteHard.vue?vue&type=template&id=0abfd5c0"
import script from "./ButtonDeleteHard.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonDeleteHard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/ButtonDeleteHard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0abfd5c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0abfd5c0', __exports__)) {
    api.reload('0abfd5c0', __exports__)
  }
  
  module.hot.accept("./ButtonDeleteHard.vue?vue&type=template&id=0abfd5c0", () => {
    api.rerender('0abfd5c0', render)
  })

}


export default __exports__